import { useTranslation } from 'react-i18next';
import { CellContext } from '@tanstack/react-table';
import { Device } from '@/types/device.types';

// TODO: Remove this once we have a proper type for the object
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeviceStatusCell = (info: CellContext<Device, any>) => {
  const { t } = useTranslation();
  const status = info.getValue();

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Inactive':
        return 'bg-yellow-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <span
      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(
        status
      )}`}
    >
      {t(`pages.devices.status.${status.toLowerCase()}`)}
    </span>
  );
};
